const REGEX = /<em>(.*?)<\/em>/g;

export const getHighlightedWords = (textHighlights: string[]): { words: string[]; hitsCount: number } => {
    if (textHighlights.length === 0) return { words: [], hitsCount: 0 };

    const uniqueWords = new Set<string>();
    let hitsCount = 0;

    for (const textHighlight of textHighlights) {
        if (!textHighlights) continue;
        let match;
        while ((match = REGEX.exec(textHighlight!)) !== null) {
            uniqueWords.add(match[1]);
            hitsCount++;
        }
    }

    return { words: [...uniqueWords.values()], hitsCount };
};
